
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-card-list',
  imports: [TranslateModule],
  templateUrl: './card-list.component.html',
  styleUrl: './card-list.component.scss'
})
export class CardListComponent {
  @Input() data: any = [];
  @Input() viewType: string = "card"
  @Input() showActions: boolean = true;  
  @Output() edit = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();

  // This method is used to handle edit event using object
  onEdit(object: any): void {
    this.edit.emit(object);
  }
  // This method is used to handle delete event using object
  onDelete(object: any): void {
    this.delete.emit(object);
  }
}
